import * as actions from './actions';
import * as getters from './getters';
import mutations from './mutations';

const state = {
  sidebar: {
    isOpen: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
